import { observer } from 'mobx-react-lite'
import { type MembershipsTabViewModel } from '@/features/user-management/MembershipsTab/MembershipsTabViewModel'
import { MembershipsSidebar } from '@/features/user-management/components/MembershipsSidebar'

export interface MembershipsSidebarContainerProps {
  vm: MembershipsTabViewModel
}

export const MembershipsSidebarContainer = observer(
  function MembershipsSidebarContainer({
    vm,
  }: MembershipsSidebarContainerProps) {
    const membershipVm = vm.selectedMembershipVm
    if (!membershipVm) {
      return null
    }

    const membership = membershipVm.membership

    return (
      <MembershipsSidebar
        workspaceId={membership.workspace.id}
        workspaceName={membership.workspace.name}
        roleName={membershipVm.roleName}
        dateJoined={membership.member.dateCreated}
        maxConcurrentProviderJobs={membership.member.maxConcurrentProviderJobs}
        jobTotals={{ ...vm.jobTotals }}
        showCoupons={!vm.isPro}
        coupons={vm.redeemedCoupons}
        skills={vm.selectedMembershipSkills}
        canEditSkills={!!membershipVm.access?.canEditUserSkills}
        teams={vm.selectedMembershipTeams}
        onBack={vm.closeSidebar}
        onAddToTeam={membershipVm.addToTeam}
        onEditRole={membershipVm.editRole}
        onEditSkills={membershipVm.editSkills}
        onManageCapacity={membershipVm.manageCapacity}
        onRemoveFromWorkspace={membershipVm.removeFromWorkspace}
      />
    )
  },
)
